import AuthTabs from "./AuthTabs";

const AuthLoginRegisterContent = () => {
  
    return (
        <div className="bg-white shadow-custom-lg max-w-lg  p-4 rounded-xl w-full">

            <img className="w-12 mb-5 mx-auto" src={`${process.env.PUBLIC_URL}/assets/images/logo/logo.webp`} alt="" />

            <h1 className="text-center font-medium mb-8 text-primary font-doran text-lg">  سامانه رزرو وقت مژه - آکادمی ساراد </h1>

            <AuthTabs />

        </div>
    )

};

export default AuthLoginRegisterContent;